import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    resourceStatics: host + 'reporter/getResourceStatics',//资源统计
    getResourceAllCount: host + 'reporter/getResourceAllCount',//全部资源
};

export const resourceStatics = (body, callBack) => {  //资源统计
    request({url:Apis.resourceStatics, body, callBack});
};
export const getResourceAllCount = (body, callBack) => {  //全部资源
    request({url:Apis.getResourceAllCount, body, callBack});
};
